// extracted by mini-css-extract-plugin
export default {"container":"pdYvTl","content":"fEQD1b","overlay":"vB5UoJ","noScroll":"JPTvo_","visible":"Rudyx7"};